import React, { useState, useEffect } from 'react'
import { Link as ScrollLink } from 'react-scroll'
import { Link as RouterLink } from 'react-router-dom'
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx";
import { motion } from 'framer-motion'
import './NavBar.css'

const NavBar = ({ hamburgerClickHandler, isOpen }) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollSections = [
        { id: 'home', title: 'Home' },
        { id: 'about-the-founder', title: 'About the Founder' },
        { id: 'contact-us', title: 'Contact Us' },
    ]

    return (
        <div className={`navbar${scrolled ? ' navbar--scrolled' : ''}`} id='navbar'>
            <div className='navbar-inner'>
                <ScrollLink
                    to="home"
                    smooth={'easeInOutQuart'}
                    duration={1500}
                    className="navbar-wordmark"
                >
                    MindForm
                </ScrollLink>
                <ul>
                    {scrollSections.map((section) => (
                        <motion.li
                            key={section.id}
                            className="nav-item"
                            whileHover="hover"
                            initial="rest"
                            animate="rest"
                        >
                            <ScrollLink
                                to={section.id}
                                spy={true}
                                smooth={'easeInOutQuart'}
                                duration={1500}
                                id={`${section.id}-link`}
                            >
                                {section.title}
                            </ScrollLink>
                            <motion.div
                                className="link-underline"
                                variants={{ rest: { width: 0 }, hover: { width: "100%" } }}
                                transition={{ duration: 0.3, type: "tween" }}
                            />
                        </motion.li>
                    ))}

                    <motion.li
                        className="nav-item nav-item--cta"
                        whileHover="hover"
                        initial="rest"
                        animate="rest"
                    >
                        <RouterLink to="/projects">Explore Our Work</RouterLink>
                    </motion.li>
                </ul>

                <div className='navbar-hamburger'>
                    {!isOpen && <RxHamburgerMenu size={18} onClick={hamburgerClickHandler} />}
                    {isOpen && <RxCross1 size={16} onClick={hamburgerClickHandler} />}
                </div>
            </div>
        </div>
    )
}

export default NavBar
